
export interface IpInfo {
    ip: string;
    country: string;
    country_code: string; // ex: FR
    city: string;
    flag: string; // URL de l'image du drapeau
    success: boolean;
}

export const getIpInfo = async (): Promise<IpInfo | null> => {
    // Priorité 1 : ipwho.is (Plus permissif pour les sites en HTTP sans SSL)
    try {
        const response = await fetch('https://ipwho.is/');
        if (response.ok) {
            const data = await response.json();

            if (data.success) {
                return {
                    ip: data.ip,
                    country: data.country,
                    country_code: data.country_code,
                    city: data.city,
                    flag: `https://flagcdn.com/w40/${(data.country_code || '').toLowerCase()}.png`,
                    success: true
                };
            }
        }
    } catch (error) {
        // Silencieux
    }

    // Priorité 2 : ipapi.co (Souvent bloqué par CORS sur HTTP simple)
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (response.ok) {
            const data = await response.json();
            
            if (data.ip && data.country_name) {
                return {
                    ip: data.ip,
                    country: data.country_name,
                    country_code: data.country_code,
                    city: data.city,
                    flag: `https://flagcdn.com/w40/${(data.country_code || '').toLowerCase()}.png`,
                    success: true
                };
            }
        }
    } catch (error) {
        // Silencieux
    }

    // 3. Fallback Final (France par défaut pour ne jamais planter)
    const randomId = Math.floor(Math.random() * 1000000);
    return {
        ip: `Anon-${randomId}`, 
        country: "France",
        country_code: "FR",
        city: "Paris",
        flag: "https://flagcdn.com/w40/fr.png",
        success: true
    };
};
